/** ExpressNET (gene expression). true en test; false en producción. */
export const isGeoBrowseEnabled = process.env.REACT_APP_GEO_BROWSE_ENABLED === 'true';
